import React from "react";
import "../../../css/CRUDModal.css";

const ViewFranchiseBalanceModal = ({ show, handleClose, item }) => {
  const handleBack = () => {
    handleClose();
  };

  const {
    mainWalletBalance = 0,
    smsBalance = 0,
    rcsBalance = 0,
    name = "",
  } = item || {};

  const balanceData = [
    {
      label: "Main Wallet Balance",
      value: `₹ ${(mainWalletBalance ?? 0).toFixed(2)}`,
    },
    {
      label: "SMS Balance",
      value: `${(smsBalance ?? 0).toFixed(0)} Qty`,
    },
    {
      label: "RCS Balance",
      value: `${(rcsBalance ?? 0).toFixed(0)} Qty`,
    },
  ];

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">View Balance</h5>
              </div>

              <div
                className="scoped-modal modal-body"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "24px",
                }}
              >
                <div className="table-container" style={{ width: "100%" }}>
                  <div className="table-wrapper">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th>Balance Type</th>
                          <th>Amount / Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {balanceData.map(({ label, value }, index) => (
                          <tr
                            key={label}
                            style={{
                              borderBottom:
                                index !== balanceData.length - 1
                                  ? "1px solid #dee2e6"
                                  : "none",
                            }}
                          >
                            <td>{label}</td>
                            <td>{value}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div
                className="scoped-modal"
                style={{
                  display: "flex",
                  justifyContent: "end",
                  padding: "12px",
                  paddingBottom: "0px",
                  gap: "16px",
                  borderTop: "1px solid #dee2e6",
                }}
              >
                <button
                  type="button"
                  className="btn btn-back"
                  onClick={handleBack}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewFranchiseBalanceModal;
